import React from 'react';
import {StyledLink} from "../../styledcomponents/MiscStyledComponents";
import ExternalLink from "./ExternalLink";
import GetExternalFeUrl, { URLSUFFIX_CONTACT_US } from '../../utils/externalUrl';

export function ContactUsLink() {
    return(
        <ExternalLink href={GetExternalFeUrl(URLSUFFIX_CONTACT_US)} style={{display : 'contents'}}>Contact Us</ExternalLink>
    )
}